import type { QuestionnairePayload, QuestionnaireStatus } from "../../form-builder/types";

export type QuestionnaireStatusFilter = "all" | QuestionnaireStatus;
export type QuestionnaireCategoryFilter =
  | "all"
  | "triage"
  | "preConsultation"
  | "postConsultation"
  | "attendance";

export function getQuestionnaireStatus(
  questionnaire: QuestionnairePayload,
): QuestionnaireStatus {
  if (questionnaire.status === "active") return "active";
  if (questionnaire.status === "unknown") return "unknown";
  return "draft";
}

export function filterQuestionnaires(
  questionnaires: QuestionnairePayload[],
  params: {
    searchQuery: string;
    statusFilter: QuestionnaireStatusFilter;
    categoryFilter: QuestionnaireCategoryFilter;
  },
): QuestionnairePayload[] {
  const normalizedSearchQuery = params.searchQuery.trim().toLowerCase();

  return questionnaires.filter((questionnaire) => {
    const normalizedTitle = questionnaire.title.trim().toLowerCase();
    const questionnaireStatus = getQuestionnaireStatus(questionnaire);

    const doesMatchName =
      normalizedSearchQuery.length === 0 ||
      normalizedTitle.includes(normalizedSearchQuery);
    const doesMatchStatus =
      params.statusFilter === "all" || questionnaireStatus === params.statusFilter;
    const doesMatchCategory =
      params.categoryFilter === "all" ||
      questionnaire.usageType === params.categoryFilter;

    return doesMatchName && doesMatchStatus && doesMatchCategory;
  });
}
